// when clicked the map pans left or right, up or down

import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

class Command extends Base<{
    out: {
        row: any;
    }
}> {

    static about = `
Pan the map left/right/up/down depending on the \`direction\` options.
    `;

    static options = {
        "direction": {
            "about": "the pan direction",
            "domain": "left|right|up|down",
        }
    }

    static output = {
        "pan": {
            "about": "the pan direction or the geometry of the feature panned to",
            "domain": "left|right|up|down or a feature geometry",
        },
    }

    execute(args = this.args) {

        let options = this.options;

        this.mediator.mapView(mapView => {

            Utils.ifOption(options, "direction", direction => {

                switch (direction) {
                    case "left": mapView.panLeft(); break;
                    case "right": mapView.panRight(); break;
                    case "up": mapView.panUp(); break;
                    case "down": mapView.panDown(); break;
                }

                this.trigger({ pan: direction });

            });

            if (args.out) {
                if (args.out.row) {
                    let feature = <Rhythm.GIS.FeatureQueryResultFeature>args.out.row.model.get("feature");
                    let geom = feature.geometry;
                    while (geom.length && typeof geom[0] === "object") {
                        geom = geom[0];
                    }
                    mapView.panTo(geom);
                    this.trigger({ pan: geom });
                }
            }

        });

    }

}

export = Command; 